/**
 * eTMF document + retention policy status — single source of truth.
 */

import { createStatusHelpers } from "./statusHelpers";

export const ETMF_DOCUMENT_STATUS = {
  DRAFT: "Draft",
  PENDING_REVIEW: "Pending Review",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  ARCHIVED: "Archived",
} as const;

export type EtmfDocumentStatus =
  (typeof ETMF_DOCUMENT_STATUS)[keyof typeof ETMF_DOCUMENT_STATUS];

const docHelpers = createStatusHelpers(
  ETMF_DOCUMENT_STATUS,
  ETMF_DOCUMENT_STATUS.DRAFT,
  {
    PendingReview: ETMF_DOCUMENT_STATUS.PENDING_REVIEW,
    PENDING_REVIEW: ETMF_DOCUMENT_STATUS.PENDING_REVIEW,
    APPROVED: ETMF_DOCUMENT_STATUS.APPROVED,
    DRAFT: ETMF_DOCUMENT_STATUS.DRAFT,
    REJECTED: ETMF_DOCUMENT_STATUS.REJECTED,
    ARCHIVED: ETMF_DOCUMENT_STATUS.ARCHIVED,
    SUPERSEDED: ETMF_DOCUMENT_STATUS.ARCHIVED,
  },
);

export const ETMF_DOCUMENT_STATUS_VALUES = docHelpers.VALUES;
export const tryNormalizeEtmfDocumentStatus = docHelpers.tryNormalize;
export const normalizeEtmfDocumentStatus = docHelpers.normalize;
export const isEtmfDocumentStatus = docHelpers.isStatus;
export const isAnyEtmfDocumentStatus = docHelpers.isAnyStatus;

export const ETMF_POLICY_STATUS = {
  ACTIVE: "Active",
  EXPIRED: "Expired",
} as const;

export type EtmfPolicyStatus =
  (typeof ETMF_POLICY_STATUS)[keyof typeof ETMF_POLICY_STATUS];

const policyHelpers = createStatusHelpers(
  ETMF_POLICY_STATUS,
  ETMF_POLICY_STATUS.ACTIVE,
  {
    ACTIVE: ETMF_POLICY_STATUS.ACTIVE,
    EXPIRED: ETMF_POLICY_STATUS.EXPIRED,
  },
);

export const ETMF_POLICY_STATUS_VALUES = policyHelpers.VALUES;
export const tryNormalizeEtmfPolicyStatus = policyHelpers.tryNormalize;
export const normalizeEtmfPolicyStatus = policyHelpers.normalize;
export const isEtmfPolicyStatus = policyHelpers.isStatus;
export const isAnyEtmfPolicyStatus = policyHelpers.isAnyStatus;
